import React from 'react'
import Grid1 from '../images/Repeat Grid 1.png'
import Grid2 from '../images/Repeat Grid 1.png'

export default function Dots() {
  return (
    <div className="dots">
       <img src={Grid1} alt="" />
       <img src={Grid2} alt="" />
    </div>
  )
}
